/*
 * views/spaView.js
 * Spa View
 */

define('app/views/spaView',[
    'lib/event',
    'app/views/commonViewHelper',
    'hbs!app/views/templates/navbar',
    'hbs!app/views/templates/breadcrumbs',
    'hbs!app/views/templates/content',
    'hbs!app/views/templates/spaLocationList',
    'hbs!app/views/templates/spaServiceTypeList',
    'hbs!app/views/templates/spaServiceList',
    'hbs!app/views/templates/spaClassCalendar',
    'hbs!app/views/templates/spaClassList',
    'hbs!app/views/templates/spaClassSelection',
    'hbs!app/views/templates/spaClassConfirm',
    'hbs!app/views/templates/spaPartialPayment',
    'bootstrap'
], function (Event, commonViewHelper, navbarTpl, breadcrumbsTpl, contentTpl, spaLocationListTpl, spaServiceTypeListTpl, spaServiceListTpl, spaClassCalendarTpl, spaClassListTpl, spaClassSelectionTpl, spaClassConfirmTpl,spaPartialPayment) {
    var spaView = {
        app:app,
        event:$.extend({}, Event),
        module:"spaBooking",
        render:function (template, data, breadcrumbs) {

        }
    };

    var setBreadCrumb = function (crumbText, crumbLink) {
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.spa = app.data.breadCrumbs.spa || [];
        var spliceCrumbsAt = -1,
            existingCrumb = $.grep(app.data.breadCrumbs.spa, function (crumb, index) {
                if (crumb.url==crumbLink) {
                    spliceCrumbsAt = index;
                    return true;
                }
                return false;
            }),
            currentCrumb = {name:crumbText, url:crumbLink};

        app.data.breadCrumbs.spa = existingCrumb.length ?
            $.merge(app.data.breadCrumbs.spa.slice(0, spliceCrumbsAt), [currentCrumb]) :
            $.merge(app.data.breadCrumbs.spa, [currentCrumb]);

        for (var i = 0; i < app.data.breadCrumbs.spa.length; i++) {
            app.data.breadCrumbs.spa[i].last = i == (app.data.breadCrumbs.spa.length - 1);
        }
    };

    spaView.event.listen('requestSpaLocationSelection', spaView, function (e, spaLocations, spaLocationSelected) {
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.spaView.module
        }));
        app.data.breadCrumbs.spa = [
            {name:app.localization.spaBooking.locationSelection.title, url:"#/spaBooking", last:true}
        ];
        var spaDate = "";
        if (app.customization.hideOtherPropertyIfItemsInCart && (app.data.spaPropertyIdsInCart.length > 0 || app.data.pmsPropertyIdsInCart.length > 0)) {
            spaLocations = _.filter(spaLocations,function(x){
                return _.some(app.data.spaPropertyIdsInCart, function(y){ return y==x.PropertyId }) || _.some(app.data.pmsPropertyIdsInCart, function(y){ return y==x.PropertyId })
            })
            if (app.data.spaPropertyIdsInCart.length == 1 && app.data.spaDateList[app.data.spaPropertyIdsInCart[0]] && app.data.spaDateList[app.data.spaPropertyIdsInCart[0]].length == 1) {
                spaDate = "/" + app.data.spaDateList[app.data.spaPropertyIdsInCart[0]][0];
            }
            if (app.data.pmsPropertyIdsInCart.length == 1 && app.data.pmsDateList[app.data.pmsPropertyIdsInCart[0]] && app.data.pmsDateList[app.data.pmsPropertyIdsInCart[0]].length >= 1) {
                spaDate = "/" + app.data.pmsDateList[app.data.pmsPropertyIdsInCart[0]][0].machine;
            }
        }
        _.each(spaLocations,function(spaLocation){
            if (!!spaLocation) {
                if  ($.isArray(app.customization.spaBooking.eventCalendarLocations) && app.customization.spaBooking.eventCalendarLocations.indexOf(spaLocation.LocationId) >= 0) {
                    spaLocation.showAsEventCalendar = true
                }
                if  ($.isArray(app.customization.spaBooking.packageBooking.packageButtonLocations) && app.customization.spaBooking.packageBooking.packageButtonLocations.indexOf(spaLocation.LocationId) >= 0) {
                    spaLocation.showPackagesButton = true
                }
                if (spaLocation.BookingType=='Service' || spaLocation.BookingType=='All') {
                    spaLocation.bookingService = true
                }
                if (spaLocation.BookingType=='Class' || spaLocation.BookingType=='All') {
                    spaLocation.bookingClass = true
                }
                
            }
        })
   
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            services:app.data.serviceTypes,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL,
            service:service
        }));
        $('#content').addClass('spaLocationListTpl').html(spaLocationListTpl({
            Localization:app.localization,
            Customization:app.customization,
            spaLocations:spaLocations,
            spaDate:spaDate,
            showitem: //$.firstOrOnly(spaLocations).LocationId
                $.isArray(spaLocations) && spaLocations.length==1
                    ? $.firstOrOnly(spaLocations).LocationId : ""
        }));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.spa
        }))
        commonViewHelper.handleServiceClick(spaLocations,spaDate)
        commonViewHelper.showMessages();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);

        commonViewHelper.prepPMSRateForm();
        commonViewHelper.analyticsInit('requestSpaLocationSelection', [spaLocations, spaLocationSelected]);
    });

    spaView.event.listen('requestSpaServiceTypeSelection', spaView, function (e, spaLocationId) {
        setBreadCrumb(app.localization.spaBooking.categorySelection.title, "#/spaBooking/location/" + spaLocationId);
        var location = app.models.spaModel.getSelectedItem('spaLocations',{});
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.spaView.module
        }));
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:Customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            service:service
        }));
        $('#content').addClass('spaServiceTypeListTpl').html(spaServiceTypeListTpl({
            Localization:app.localization,
            location:location
        }));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.spa
        }))
        commonViewHelper.showMessages();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
    });

    spaView.event.listen('requestSpaServiceSelection', spaView, function (e, spaServices, itemId, location, date, time, staffGenderOrId, guestName, dateList, user, group) {
        setBreadCrumb(app.localization.spaBooking.categorySelection.selectService, "#spaBooking/service");


        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (arr) {
            return arr.id == 'spaBooking'
        }));
        /*  var location = $.firstOrOnly($.grep(app.data.spaLocations.SpaLocation,function(arr){
         return arr.LocationId==app.data.selectedSpaLocation
         }));*/
        if  ($.isArray(app.customization.spaBooking.eventCalendarLocations) && app.customization.spaBooking.eventCalendarLocations.indexOf(location.LocationId) >= 0) {
            location.showAsEventCalendar = true
        }
        var category = _.find(spaServices, function (x) {
            return _.some(x.value, function (y) {
                return y.SpaItemId && (y.SpaItemId == itemId)
            })
        })

        _.each(spaServices, function (v, k, l) {
            l[k].value = _.sortBy(l[k].value, function (s) {
                return app.customization.spaBooking.sortByPrice ? +s.Price : s.ItemName
            });
            app.customization.spaBooking.showPriceIncludingSurcharges
                && _.each(l[k].value, function(s,i){
                    s.PriceWithSurcharges && (l[k].value[i].Price = s.PriceWithSurcharges);
                })
        })
        spaServices = _.sortBy(spaServices, function (s) {
            return s.name
        });

        dateList = _.uniq(_.sortBy(dateList,function(x){
            return x.machine
        }), true, function(x){
            return x.machine
        });
        var templateData = {
            categories:spaServices,
            location:location,
            staffGenderOrId:staffGenderOrId,
            guestName:guestName,
            Customization:app.customization,
            Localization:app.localization,
            showitem:itemId,
            showcategory:category,
            staffOrGender: (location.ForceGenderSelect=='Y' || location.AllowStaff=='Y' || location.AllowGender=='Y') ? "Y" : "N",
            dateList: dateList,
            selectedDate: date,
            user: user,
            group: group,
            url: window.location.hash.replace(/^#/, ''),
            showBookForGroupMember: user.CustomerId && !app.customization.spaBooking.disallowBookForGroupMember
        };
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:Customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            service:service
        }));
        $('#content').addClass('spaServiceListTpl').html(spaServiceListTpl(templateData));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.spa
        }))
        console.log(location, app.localization);
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.prepSpaForm(location, itemId, date, time, staffGenderOrId, templateData);
        commonViewHelper.showMessages();
    });


    spaView.event.listen('updateSpaServiceStaffList', spaView, function (e, params) {
        console.log('updateSpaServiceStaffList', arguments)
        commonViewHelper.updateSpaServiceStaffList(params.showitem, params.staffList, params.staffGenderOrId, params.location, params.type, params.value);
    });
    spaView.event.listen('requestSpaServiceStaffListUpdate', spaView, function (e, itemId) {
        console.log('requestSpaServiceStaffListUpdate', arguments)
    });
    spaView.event.listen('updateSpaItemAvailability', spaView, function (e, params) {
        console.log('updateSpaItemAvailability', params)
        commonViewHelper.updateSpaItemAvailability(params);
    });


    spaView.event.listen('spaEventCalendar', spaView, function (e, spaLocationId, startDate, showItem, guestName, spaItemId, user, group) {
        setBreadCrumb(app.localization.spaBooking.classSelection.title, "#/spaBooking/class/" + spaLocationId);
        var location = app.models.spaModel.getSelectedItem('spaLocations',{});
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.spaView.module
        }));
        
        if  ($.isArray(app.customization.spaBooking.packageBooking.packageButtonLocations) && app.customization.spaBooking.packageBooking.packageButtonLocations.indexOf(location.LocationId) >= 0) {
            location.showPackagesButton = true
        }
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:Customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            service:service
        }));
        $('#content').addClass('spaClassCalendarTpl').html(spaClassCalendarTpl({
            Localization:app.localization,
            Customization:app.customization,
            spaLocationId:spaLocationId,
            location:location,
            user:user,
            group:group
        }));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.spa
        }))
        commonViewHelper.handleServiceClickOnEventPage(location,'')
        commonViewHelper.prepSpaEventCalendar(spaLocationId, startDate, showItem, guestName, spaItemId, location, user, group);
        commonViewHelper.showMessages();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
    });

        spaView.event.listen('requestSpaClassDateSelection', spaView, function (e, spaLocationId, startDate, dateList, guestName, user, group, location) {
        setBreadCrumb(app.localization.spaBooking.classSelection.title, "#/spaBooking/class/" + spaLocationId);
        var location = app.models.spaModel.getSelectedItem('spaLocations',{});
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.spaView.module
        }));
        dateList = _.uniq(_.sortBy(dateList,function(x){
            return x.machine
        }), true, function(x){
            return x.machine
        });
        if  ($.isArray(app.customization.spaBooking.packageBooking.packageButtonLocations) && app.customization.spaBooking.packageBooking.packageButtonLocations.indexOf(location.LocationId) >= 0) {
            location.showPackagesButton = true
        }
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:Customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            service:service
        }));
        $('#content').addClass('spaClassListTpl').html(spaClassListTpl({
            Localization:app.localization,
            location:location,
            spaLocationId:spaLocationId,
            dateList: dateList,
            startDate:startDate
        }));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.spa
        }))

        commonViewHelper.handleServiceClickOnClassPage(location,'')
        commonViewHelper.prepClassForm(spaLocationId, startDate, location);
        commonViewHelper.showMessages();
        startDate || commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
    });
//                        app.views.spaView.event.fire('requestClassSelection',[r_sc, startDate, showItem, spaLocationId, guestName]);

    spaView.event.listen('requestClassSelection', spaView, function(e, classInfo, startDate, showItem, spaLocationId, guestName, spaItemId){

        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.spaView.module
        }));
        var category = _.find(classInfo, function (x) {
            return _.some(x.value, function (y) {
                var isSpaItem = y.SpaItemId && (y.SpaItemId == spaItemId);
                isSpaItem && y.SpaClassId && !showItem && (showItem = y.SpaClassId);
                return (y.SpaClassId && (y.SpaClassId == showItem)) || isSpaItem
            }) || classInfo.length==1
        }) || ""
        _.each(classInfo, function (v, k, l) {

            //grouping classes by its class ids and storing its unique staffIds - start
            var classesBySpaClassId = _.groupBy( l[k].value,'SpaClassId'),
                classes = []
            _.each(classesBySpaClassId,function(classGroup){
                classGroup[0]._staffIds = _.pluck(classGroup,'SpaStaffId')
                classes.push(classGroup[0])
            })
             //grouping classes by its class ids and storing its unique staffIds - start
            l[k].value = classes
            l[k].value = _.sortBy(l[k].value, function (s) {
                return app.customization.spaBooking.sortClassesByDate ? s.StartTime
                        : (app.customization.spaBooking.sortByPrice ? +s.Price : s.SpaItemName)
            });
            app.customization.spaBooking.showPriceIncludingSurcharges
                && _.each(l[k].value, function(s,i){
                    s.PriceWithSurcharges && (l[k].value[i].Price = s.PriceWithSurcharges);
                })
        })
        classInfo = _.sortBy(classInfo, function (s) {
            return s.name
        });
     
        var location = app.models.spaModel.getSelectedItem('spaLocations',{});
        $('#classResults').html( spaClassSelectionTpl( {
            Localization : app.localization,
            categories: classInfo,
            showitem: showItem,
            showcategory: category,
            spaLocationId: spaLocationId,
            guestName:guestName,
            location:location,
            spaItemId: spaItemId
//            firstTeeTime: firstTeeTime,
//            numberOfPlayers: numberOfPlayers,
//            location: app.models.golfModel.getSelectedValue("golfLocations")
        } ));

        commonViewHelper.showMessages();
        commonViewHelper.prepClassSelectionForm(spaLocationId, location, spaItemId,classInfo);
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
    });

    spaView.event.listen('confirmSpaClass', spaView, function(e, location,item,spaLocationId, classId, itemId, startDate, bookingtype,hasGroupMember){
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.spaView.module
        }));

        if (itemId && item.GroupItems && item.GroupItems.Item) {
            var bookeditem = _.find(item.GroupItems.Item,function(groupItem){
                return groupItem.id == itemId
            })
            if (bookeditem) {
                item.SpaItemName = bookeditem.GroupItemName
                item.Price = bookeditem.GroupItemPrice
                item.PriceWithSurcharges = bookeditem.GroupItemPriceSurcharges
                item.ServiceTime = bookeditem.GroupItemServiceTime
            }
        }
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:Customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            service:service
        }));
        if(item.IsProgramHeader != "Y"){
        $('#content').addClass('spaClassConfirmTpl').html( spaClassConfirmTpl( {
            Localization : app.localization,
            location:location,
            item:item,
            spaLocationId:spaLocationId,
            classId:classId,
            itemId:itemId,
            startDate:startDate,
            hasGroupMember:hasGroupMember,
            hasGrouping: (!!hasGroupMember ? 1:0),
            guestDetails:((app.data.spaClassQueue || {})[startDate+'-'+classId] ||[(app.data.user_equipment_not_loggedin|| {})])||[],
            bookingtype:bookingtype
        } ));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.spa
        }))       
        commonViewHelper.prepSpaClassConfirmForm()}
        else{
            $('body').addClass('content-spaPackageTpl')
            $('body #main').empty().append('<div class="container whitebg"><div id="vue-optional-class-app" /></div>');
            require(['optionalClassProgram/starter'], function (starter) {
                if(app.data.optionalClassVueAppRef) app.data.optionalClassVueAppRef.$destroy();
                item.locationName = location.LocationName

                starter(item);
            })
        }
        commonViewHelper.showMessages();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        // commonViewHelper.prepClassSelectionForm(spaLocationId, location);
        var spaClassesQueue = ((app.data.spaClassQueue || {})[startDate+'-'+classId] ||[(app.data.user_equipment_not_loggedin|| {})])||[]
        app.commonViewHelper.analyticsInit('spaClassConfirm', [spaClassesQueue, location, startDate]);
    });

    spaView.event.listen('updateMessages', spaView, function(e){
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.spaView.module
        }));
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
    });

    spaView.event.listen('requestSpaPartialPayment', spaView, function(e, spaFolio,folioId,isAllowedAccess){
        var service = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
            return a.id==app.views.roomsView.module
        }));
        if(!_.isEmpty(spaFolio)){
            spaFolio.SpaFolioItem =  [].concat(spaFolio.SpaFolioItem)
            spaFolio.SpaFolioItem.forEach(function (folioItem) {
                folioItem.BookStartTime = Date.parseExact(folioItem.BookStartTime, "yyyy-MM-ddHHmmss").toString('ddd, dd MMMM yyyy')
                folioItem.BookEndTime  = Date.parseExact(folioItem.BookEndTime, "yyyy-MM-ddHHmmss").toString('ddd, dd MMMM yyyy')
            })
           
        }
        setBreadCrumb("Summary");
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : app.customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            bannerMessage : app.localization.roomReservation.marketing.bannerMessage,
        }) );
        $('#content').addClass('spaPartialPayment').html(spaPartialPayment( {
            spaFolio:spaFolio,
            Localization : app.localization,
            loggedInUser :  app.data.CustomerId,
            folioId:folioId,
            isAllowedAccess: isAllowedAccess
        }))
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':"Summary"
        }) )
  
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.handlePaymentPageDOM(folioId,'SPA');
           
       
    }),
    spaView.event.listen('renderPackageView', spaView, function (e, params) {
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.spaView.module
        }));
        if(app.data.reRunVueApp){
            app.datal('reRunVueApp',false);
        }else if($('.vue-app-container').length > 0) { 
            if(app.data.vueAppRef) {
                params.doNotUpdate = true;
                app.data.vueAppRef.$store.commit('updateStoreOnUrlChange',params)
            }
            return;
        };
         //below code is commented as it is not required to reset the navbar ui ref #11142
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:Customization.serverURL
        }));
        $('body').removeClass (function (index, css) {
            return (css.match (/(^|\s)content-\S+/g) || []).join(' ');
          });
        $('body').addClass('content-spaPackageTpl')
        $('body #main').empty().append('<div class="vue-app-container"><div id="vue-app" /></div>');
        require(['app/views/vue/vue-starter'], function (starter) {
            if(app.data.vueAppRef) app.data.vueAppRef.$destroy();
            starter(params);
            $('.nav.navbar-outter.navbar-login-option').remove();
            $('#progressIndicator').modal('hide');
        });
        commonViewHelper.showMessages();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
    });

    spaView.event.listen('requestBookingTypeSelectionAfterSpa', spaView, function (e,spaLocations,params) {
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.spaView.module
        }));
        console.log('request BookingTypeSelection');
        $('#main').empty().append('<div id=vue-app-mode></div>')
        require(['modeSelector/starter'], function (starter) {
            if(app.data.modeSelectorVueAppRef) app.data.modeSelectorVueAppRef.$destroy();
            starter({view:'spaView',event:'requestSpaLocationSelection', paramsArr:[spaLocations,params]});
        })
        commonViewHelper.showMessages();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
    });
    // spaView.event.listen('requestBookingTypeSelectionAfterSpa', spaView, function (e,spaLocations,params) {
    // //     console.log('request BookingTypeSelection');
    // //     $('#main').empty().append('<div id=vue-optional-class-app></div>')
    // //     require(['optionalClassProgram/starter'], function (starter) {
    // //         if(app.data.modeSelectorVueAppRef) app.data.modeSelectorVueAppRef.$destroy();
    // //         starter({view:'spaView',event:'requestSpaLocationSelection', paramsArr:[spaLocations,params]});
    // //     })
    //  });
   
    return window.app.views.spaView = spaView;

});

